import { useEffect, useRef } from 'react';
import throttle from 'lodash.throttle';

/**
 * Handle show and hide functionality of the header on scroll.
 *
 * @returns {React.MutableRefObject}
 */
function useHeaderScroll() {
  const headerRef = useRef(null);
  const prevScrollPos = useRef(0);

  const handleFixedPosition = throttle(event => {
    if (headerRef.current) {
      const scrollPos = event.target.documentElement.scrollTop;

      if (scrollPos > prevScrollPos.current && scrollPos >= 160)
        headerRef.current.style.transform = 'translateY(-100%)';
      else headerRef.current.style.transform = 'translateY(0)';

      prevScrollPos.current = scrollPos <= 0 ? 0 : scrollPos;
    }
  }, 100);

  useEffect(() => {
    window.addEventListener('scroll', handleFixedPosition, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleFixedPosition, { passive: true });
    };
  }, []);

  return { headerRef };
}

export default useHeaderScroll;
